<h3 class="text-center mt-3">Formulario de recurrencia</h3>
<div class="p-5 m-auto">
    <form [formGroup]="recurringForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-1">
            <label class="font-weight-bold">Repetir</label>
        </div>

        <div class="form-group">
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" id="daily" checked formControlName="frequency"
                    [value]="Frequency.DAILY" />
                <label class="custom-control-label form-check-label" for="daily">
                    Diario
                </label>
            </div>

            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" id="weekly" formControlName="frequency"
                    [value]="Frequency.WEEKLY" />
                <label class="custom-control-label form-check-label" for="weekly">
                    Semanal
                </label>
            </div>

            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" id="monthly" formControlName="frequency"
                    [value]="Frequency.MONTHLY" />
                <label class="custom-control-label form-check-label" for="monthly">
                    Mensual
                </label>
            </div>
        </div>

        <div class="form-group mb-1">
            <label class="font-weight-bold">Cada</label>
        </div>

        <div class="form-group mb-1">
            <div class="input-group">
                <input class="form-control" name="interval" formControlName="interval" type="number">
                <label>Intervalo</label>
            </div>
        </div>

        <ng-container *ngIf="f.frequency.value === Frequency.WEEKLY">
            <div class="form-group mb-1">
                <label class="font-weight-bold">Repetir</label>
            </div>

            <div class="btn-group btn-group-toggle mb-2" formArrayName="onWeekday">
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="0" ngbButton> Mon
                </label>
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="1" ngbButton> Tue
                </label>
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="2" ngbButton> Wed
                </label>
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="3" ngbButton> Thu
                </label>
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="4" ngbButton> Fri
                </label>
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="5" ngbButton> Sat
                </label>
                <label class="btn-primary" ngbButtonLabel>
                    <input type="checkbox" formControlName="6" ngbButton> Sun
                </label>
            </div>
        </ng-container>

        <ng-container *ngIf="f.frequency.value === Frequency.MONTHLY">
            <div class="form-group">
                <label class="font-weight-bold" for="onMonthday">Día del mes</label>
                <div class="input-group" style="width: 250px;">
                    <input id="onMonthday" class="form-control" name="dp"
                        formControlName="onMonthday" type="number">
                </div>
            </div>
        </ng-container>

        <div class="form-group mb-1">
            <label class="font-weight-bold">Terminar repetición</label>
        </div>

        <div class="form-group ml-2">
            <label>En </label>
            <div class="input-group">
                <input #dpToDate matInput name="until" (input)="setEndDate(dpToDate.value)"
                    [value]="f['endDate'].value" formControlName="until" type="datetime-local">
            </div>
        </div>

        <div class="form-group mb-1">
            <label class="font-weight-bold">Después de </label>
        </div>

        <div class="form-group ml-2">
            <div class="input-group">
                <input class="form-control" name="count" formControlName="count" type="number">
                <label class="font-weight-bold">ocurrencia/s</label>
            </div>
        </div>

        <button type='submit'> Ver Recurrencia </button>

        <button type='button' (click)="createRecurrence()"> Crear Recurrencia </button>

        <div class="form-group">
            <div class="form-control-plaintext">
                <p class="font-weight-bold">Number of occurrences: {{ dates.length }}</p>
                <p class="font-weight-bold">Dates</p>
                <span class="d-inline-block mr-3" *ngFor="let date of dates">
                    {{ date | date:'yyyy-MM-dd' }}
                </span>
            </div>
        </div>
    </form>
</div>
